import {ref} from "vue"
import {defineStore} from 'pinia'

export const useKMessageStore = defineStore('messageStore', () => {
    const messages = ref<{ id: string, text: string, type: string, closeable?: boolean, show: boolean}[]>([])

    const clear = (id: string) => {
        messages.value = [...messages.value.filter(entry => entry.id !== id)]
    }

    const push = (type: 'error' | 'info' | 'success' | 'warning', text: string, closeable?: boolean) => {
        messages.value = [...messages.value, {
            id: window.crypto.randomUUID(),
            text: text,
            type: type,
            closeable: closeable,
            show: true}]
    }

    return {
        // state
        messages,
        // getters
        // actions
        clear,
        push,
    }
})
